/**
 * Fun facts about Australian property and cities
 * Displayed during loading to make the wait more engaging
 */
export const funFacts = [
  // Melbourne facts
  "Melbourne has the largest tram network in the world, with over 250km of track.",
  "Fitzroy has more cafes per capita than any other suburb in Australia.",
  "Melbourne's laneways contain over 80% of the city's street art.",
  
  // Sydney facts
  "The average Sydney commuter spends 71 minutes traveling each day.",
  "Bondi Beach attracts over 2.7 million visitors annually.",
  "Sydney has more than 100 beaches within its greater metropolitan area.",
  "The Sydney Opera House has over 1 million tiles on its roof.",
  
  // Brisbane facts
  "Brisbane has more sunshine hours than any other Australian capital city.",
  "The Brisbane River has 17 bridges crossing it.",
  "Brisbane's Fortitude Valley was Australia's first dedicated entertainment precinct.",
  
  // Perth facts
  "Perth is the most isolated major city in the world.",
  "Perth has more restaurants per capita than any Australian city.",
  "Fremantle's cappuccino strip was Australia's first cafe culture hub.",
  
  // Adelaide facts
  "Adelaide was the first Australian city to grant women the right to vote.",
  "Adelaide has more wine regions within an hour's drive than any other city.",
  "North Adelaide is one of Australia's oldest suburban areas, established in 1837.",
  
  // General Australian property facts
  "The median Australian property price has increased 412% since 1993.",
  "Australians spend an average of 7 years in each home before moving.",
  "Over 67% of Australians own their home, one of the highest rates globally.",
  "The concept of SEIFA scores was developed by the ABS in 1986.",
  "Census 2021 captured data on 25.4 million Australians.",
  "Australia has approximately 10.8 million residential dwellings.",
  "The average Australian mortgage is paid off in 30 years.",
  
  // Transport facts
  "Australian capital cities have a combined 8,500+ km of public transport routes.",
  "Melbourne's train network carries over 250 million passengers annually.",
  "Sydney's light rail carries 13 million passengers per year.",
  
  // Quirky facts
  "The most expensive street in Australia is Wolseley Road, Point Piper.",
  "Australian homes are among the largest in the world, averaging 214 sqm.",
  "The first property sale in Sydney was in 1788, for a barrel of rum.",
];

/**
 * Get a random fun fact
 */
export const getRandomFact = (): string => {
  const randomIndex = Math.floor(Math.random() * funFacts.length);
  return funFacts[randomIndex];
};

/**
 * Get a fact relevant to a specific city (if possible)
 */
export const getFactForCity = (city: string): string => {
  const cityLower = city.toLowerCase();
  
  // Try to find a city-specific fact
  const cityFacts = funFacts.filter(fact => 
    fact.toLowerCase().includes(cityLower) ||
    (cityLower === 'melbourne' && fact.toLowerCase().includes('fitzroy')) ||
    (cityLower === 'sydney' && fact.toLowerCase().includes('bondi')) ||
    (cityLower === 'perth' && fact.toLowerCase().includes('fremantle'))
  );
  
  // Return city-specific fact or random fact
  if (cityFacts.length > 0) {
    return cityFacts[Math.floor(Math.random() * cityFacts.length)];
  }
  return getRandomFact();
};

export default funFacts;


